// removed by extract-text-webpack-plugin
module.exports = {"list":"_3_BtSfLtlLigoji3xIJQq4","summary":"_3RIUulrHE2gEEOvTxcFjYB","summaryHide":"_1bjJnab-en_V7AJAI4Y6rx","detailHide":"_1gvLfLZHG26x2FLIAd1OA5","location":"Y50HdOuGnruKNflTo7AUq","header":"_3RSqs8k4N0AGMBYPtDYNM6","text":"_2hd8q5VJkJab-6LbZHSPdb","address":"_2cHuNgBlmcYucOR5HRmEZ7","distance":"sD-3rnPLDgMxjerInGdKR","none":"_1Og5tNiUizMASDsMGSCeAZ"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/List/style.scss
// module id = 977
// module chunks = 0